import React from 'react'

const setDefaultReturn = (target, defaultReturn = <React.Fragment />) =>
  new Proxy(target, {
    get: (obj, prop) => (prop in obj ? obj[prop] : defaultReturn),
  })

export default setDefaultReturn
